// Constants + small helpers shared across Orders.jsx and its sub-components.
// Extracted from screens/Orders.jsx so the parent stays a slim composer.

import { C } from "../../lib/theme";

// DB sub_order.status → UI step (0-4) + display label.
// Schema enum: pending_payment, confirmed, preparing, shipped, delivered, completed, cancelled, refunded.
export const STATUS_MAP = {
  pending_payment: { progress: 0, label: "Placed",          tone: "amber" },
  confirmed:       { progress: 1, label: "Confirmed",       tone: "green" },
  preparing:       { progress: 2, label: "Being prepared",  tone: "amber" },
  shipped:         { progress: 3, label: "Out for delivery", tone: "blue" },
  delivered:       { progress: 4, label: "Delivered",       tone: "muted" },
  completed:       { progress: 4, label: "Completed",       tone: "muted" },
  cancelled:       { progress: 0, label: "Cancelled",       tone: "red" },
  refunded:        { progress: 0, label: "Refunded",        tone: "muted" },
};

export const STEPS = ["Placed", "Confirmed", "Preparing", "On the way", "Delivered"];

export const TONE = {
  amber: { bg: C.amberBg, fg: C.amberDk },
  green: { bg: C.greenBg, fg: C.greenDk },
  blue:  { bg: C.blueBg,  fg: C.blueDk },
  muted: { bg: C.cream,   fg: C.muted },
  red:   { bg: C.redBg,   fg: C.red },
};

export const DELIVERY_LABEL = {
  courier: "Courier delivery",
  pickup:  "Store pickup",
};

export const PAYMENT_LABEL = {
  airtel: "Airtel Money",
  mtn:    "MTN Mobile Money",
  momo:   "MTN Mobile Money",
  card:   "Card (Visa / Mastercard)",
  visa:   "Visa / Mastercard",
};

export const PAYMENT_ICON = {
  airtel: "smartphone",
  mtn:    "smartphone",
  momo:   "smartphone",
  card:   "credit-card",
  visa:   "credit-card",
};

// "Today · 14:30" / "Yesterday · 09:12" / "Tue · 11:45"
export function fmtWhen(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();
  const sameDay = d.toDateString() === now.toDateString();
  const hhmm = d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  if (sameDay) return `Today · ${hhmm}`;
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (d.toDateString() === yesterday.toDateString()) return `Yesterday · ${hhmm}`;
  return d.toLocaleDateString([], { weekday: "short" }) + ` · ${hhmm}`;
}

export function itemTitle(it) {
  return it?.products?.title || it?.product_name || "Item";
}

export function firstItemTitle(o) {
  const items = o.order_items || [];
  if (!items.length)      return "Order " + (o.orders?.order_number || o.id.slice(0, 6));
  if (items.length === 1) return `${itemTitle(items[0])} × ${items[0].quantity}`;
  return `${itemTitle(items[0])} + ${items.length - 1} more`;
}

export function firstItemImage(o) {
  const items = o.order_items || [];
  const first = items[0];
  const arr = first?.products?.images;
  if (Array.isArray(arr) && arr.length) {
    const img = arr[0];
    if (typeof img === "string") return img;
    return img?.thumb || img?.med || img?.full || null;
  }
  return first?.product_image || null;
}
